import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import {isMobile} from "react-device-detect";
import {CONSTANTS} from "../../config/constants";

export function useCleanLayout() {
	const { pathname } = useLocation();

	const hideNavBar = useMemo(() => {
		return isMobile && CONSTANTS.HIDDEN_NAV_ROUTES.some((r) => r.test(pathname));
	}, [pathname]);

	const hideFooter = useMemo(() => {
		return isMobile && CONSTANTS.HIDDEN_FOOTER_ROUTES.some((r) => r.test(pathname));
	}, [pathname]);

	const isSeatMapLayout = useMemo(() => {
		return hideNavBar &&  hideFooter;
	}, [pathname]);

	return {
		hideNavBar,
		hideFooter,
		isSeatMapLayout,
	}
}
